import React, { Component, Fragment } from "react";
import AppContext from "../../contexts/AppContext";

class GoogleTag extends Component {
    GoogleTag = function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.defer =  true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
    };

    render() {
        return (
            <Fragment>
                {this.GoogleTag(
                    window,
                    document,
                    "script",
                    "dataLayer",
                    "GTM-W34FMHK"
                )}
            </Fragment>
        );
    }
}

GoogleTag.contextType = AppContext;
export default GoogleTag;



// WEBPACK FOOTER //
// ./src/components/auth/GoogleTag.js